<template>
  <div class="wrappertabs">


    <search-group title="" @search="findData" @clear="clearValue" :span="24" :btnOffset="20" :btnSpan="6"
                  :multipleLines="false" :inline="true"
                  style="padding: 0"
    >
      <Row class="mb16" :gutter="16">
        <Col span="6">
          <Select v-model="searchData.projectFid" placeholder="项目名称">
<!--            <Option value=''>请选择</Option>-->
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="5">
          <Select v-model="searchData.businessCode" placeholder="费用项">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in typeList" :value="item.value" :key="'keyB2'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="5">
          <DatePicker type="month"
                      v-model="searchData.belongToMonth"
                      format="yyyy-MM"
                      placeholder="归属月份" style="display: block"></DatePicker>
        </Col>
        <Col span="8">
          <DatePicker style="width:100%" v-model="searchData.createTime" split-panels type="daterange" format="yyyy-MM-dd"
                      placeholder="收入记账日期筛选"></DatePicker>
        </Col>

      </Row>

      <Row class="mb16" :gutter="16">

        <Col span="6">
          <Input placeholder="请搜索摘要、预算项、财务科目" v-model="searchData.condition"></Input>
        </Col>
      </Row>

    </search-group >
    <div style="padding-top: 0;">
      <Button v-p="{api:'incomeCostItem/otherIncome/batchImport'}" type="primary" @click.stop="importN++" class="mb16">导入</Button>
      <Button v-p="{api:'incomeCostItem/exportOrtherIncome'}" type="primary" :loading = "btnLoading" @click="exportFile()" class="mb16" style="margin-left:10px">导出</Button>
    </div>
    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    ></table-list>
    <import-file
    :i="importN"
    @done="getData"
    ></import-file>

  </div>

</template>

<script type="text/ecmascript-6">
  import SearchGroup from 'components/SearchGroup/index';
  import {formatDateTime} from "@/utils/format";
  import TableList from 'components/TableList/index';
  import {incomelist,businessCodecondition,exportOrtherIncome} from "@/api/gop";
  import {formatMoney} from "@/utils/format";
  import {getProjects} from "@/api/common";
  import ImportFile  from './components/ImportFile'


  export default {
    components: {
      SearchGroup,
      TableList,
      ImportFile
    },
    props: {
      // projectList:{
      //   type:Array,
      //   default:()=>{return []}
      // }
    },
    created(){
      getProjects().then(res => {
        if(!res.data){
          return
        }
        this.projectList = res.data
        if(this.projectList && this.projectList.length>0){
          this.searchData.projectFid=this.projectList[0].value
          this.findData()

        }

      }).catch(error => {
      })

    },
    mounted() {
      businessCodecondition({type:2}).then(res=>{
        if(!res.data){
          return
        }
        this.typeList=res.data
      }).catch(error=>{
      })
    },
    computed: {
      searchDataComputed() {
        function f(data) {
          return data ? formatDateTime(data, false) : ''
        }
        return {
          condition:this.searchData.condition,
          projectFid: this.searchData.projectFid,
          startHappenDate: f(this.searchData.createTime[0]),
          endHappenDate:f(this.searchData.createTime[1]),
          businessCode:this.searchData.businessCode,
          belongToMonth:f(this.searchData.belongToMonth).slice(0,7),
        }
      }
    },
    data() {
      return {
        importN:0,
        projectList:[],
        typeList:[],
        searchParams:null,
        data: [],
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: ' '
          },
          {
            title: '项目名称 ',
            align: 'center',
            key: 'projectName',
            width: 130,
          },
          {
            title: ' '
          },
          {
            title: '费用项 ',
            align: 'center',
            key: 'businessName',
            width: 100,
          },
          {
            title: ' '
          },        {
            title: "预算项",
            align: 'center',
            key: 'budgetName',
            width: 120,
            // render:(h,params)=>{
            //   return h('span',{},formatDateTime(params.row['startDate'],false))
            // }
          },
          {
            title: ' '
          },

          {
            title: "金额",
            align: 'center',
            key: 'incomeMoney',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatMoney(params.row['incomeMoney']))
            }
            // render:(h,params)=>{
            //   return h('span',{},formatDateTime(params.row['releaseDate'],false))
            // }
          },
          {
            title: ' '
          },

          {
            title: "发生日期",
            align: 'center',
            key: 'happenDate',
            width: 120,
            render: (h, params) => {
              return h('span', {}, formatDateTime(params.row['happenDate'], false))
            }
          },
          {
            title: ' '
          },
          {
            title: " 记账日期 ",
            align: 'center',
            key: 'bookingDate',
            width: 120,
            render: (h, params) => {
              return h('span', {}, formatDateTime(params.row['bookingDate'], false))
            }
          },
          {
            title: ' '
          },
          {
            title: " 财务科目 ",
            align: 'center',
            key: 'feeName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "摘要 ",
            align: 'center',
            key: 'summary',
            width: 140,
            render: (h, params) => {
              if (params.row['summary'] && params.row['summary'].length > 7) {
                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['summary']),
                  h('span', {}, params.row['summary'].slice(0, 7) + '...')


                ])

              } else {
                return h('span', {}, params.row['summary'])
              }
            }
          },

          {
            title: ' '
          },
          {
            title: "归属月份",
            align: 'center',
            key: 'belongToMonth',
            width: 120,
          }
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchData: {
          projectFid: '',
          createTime: ['', ''],
          condition:'',
          businessCode:'',
          belongToMonth:'',
        },
        btnLoading:false,
      }
    },
    methods: {
      exportFile(){
        let data = {};
        for (let key in this.searchParams) {
          if(key==='page' || key==='limit') continue;
          data[key] = this.searchParams[key]
        }
        this.btnLoading = true;
        exportOrtherIncome(data).then( res => {
          let con = console;
          con.log(res.headers)
          if(res.headers.count > 1000){
            this.btnLoading = false;
            this.$Modal.info({
              title: '导出合同',
              content:'上限10000条，请选择条件后下载'
            });
          } else{
            let filename = res.headers.filename || 'excel.xls';
            let blob = new Blob([res.data]);
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            this.btnLoading = false
          }
        }).catch( err => {
          this.btnLoading = false;
          console.log(err)
        })
      },
      getData(){
        let params={
          type:2,
          ...this.searchParams,
          page:this.page,
          limit:this.limit
        }
        incomelist(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          this.data=res.data.rows?res.data.rows:[]


        }).catch(error=>{
        })

      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
        this.searchData = {
          projectFid: '',
          createTime: ['', ''],
          condition:'',
          businessCode:'',
          belongToMonth:'',
        }
      },
    },
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
</style>
